import { useRef, useState } from "react"
import { useSelector } from "react-redux";
import IconHeaderBackground from "../IconHeaderBackground";
import Search from "../Search";
import SearchIconDark from '../../../../../assests/header/icons/search-icon-dark.png'
import SearchIconWhite from '../../../../../assests/header/icons/search-icon-white.png'
import classes from '../Icons.module.css'
import useClickOutside from "../../../../../hooks/useClickOutside"
import Soon from "../../../../UI/Soon";
import { onKeyDown } from "../../../../../service";

const SearchBtn = ({ filtercb, filters }) => {
    const [showSearchPopup, setShowSearchPopup] = useState(false)
    const popupRef = useRef(null);
    const texts = useSelector(state => state.translate.texts);

    useClickOutside(popupRef, () => {
        setShowSearchPopup(false);
    });
    function open(e) {
        setShowSearchPopup(prevshowSearchPopup=>!prevshowSearchPopup)
    }
    return (
        <>
            <div ref={popupRef}  className={` ${!showSearchPopup ? classes.Icon : classes.OpenIconImg}`}>
                <img src={` ${showSearchPopup ?SearchIconDark:SearchIconWhite}`} alt='SearchIcon' className={classes.IconImg} onClick={(e) => open(e)}  tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => open(e))}/>
                    <div style={{ display: !showSearchPopup ? 'none' : 'block' }}>
                        <IconHeaderBackground title={texts.Search} close={() => setShowSearchPopup(false)}>
                           { filters ? <Search filtercb={filtercb} filters={filters}></Search>:<Soon></Soon>}
                        </IconHeaderBackground>
                    </div>
            </div>
        </>
    )
}
export default SearchBtn